import axios from "axios";

const EndPoint = "https://app.kanhahometutions.com/api/v1";
// const EndPoint = "http://127.0.0.1:8000/api/v1";

const axiosInstance = axios.create({
  baseURL: EndPoint,
  timeout: 1000000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

// Request Interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    try {
      const user = localStorage.getItem("user");

      if (user) {
        const parsedUser = JSON.parse(user);
        const token = parsedUser?.accessToken;

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (error) {
      console.error("Invalid user data in localStorage");
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
